// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询案例频道股池策略部统计 GET /stock/case/channel/cl-statistics/info */
export async function stockCaseChannelClStatisticsInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultCaseChannelClStatisticsInfoResp>(
    '/stock/case/channel/cl-statistics/info',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 案例股票池频道列表 GET /stock/case/channel/list */
export async function stockCaseChannelListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChannelListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockCaseChannelItem>('/stock/case/channel/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池频道列表(PC端) GET /stock/case/channel/pc */
export async function stockCaseChannelPcUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListPcStockCaseChannelItem>('/stock/case/channel/pc', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取聊天室案例老师 GET /stock/case/chat/case/analyst */
export async function stockCaseChatCaseAnalystUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatCaseAnalystUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCaseAnalystResp>('/stock/case/chat/case/analyst', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 聊天室案例操作列表(全部) GET /stock/case/chat/deal/all */
export async function stockCaseChatDealAllUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatDealAllUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/deal/all', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 聊天室案例操作列表 GET /stock/case/chat/deal/list */
export async function stockCaseChatDealListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatDealListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/deal/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 聊天室案例列表 GET /stock/case/chat/list */
export async function stockCaseChatListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 聊天室案例-我的关注 GET /stock/case/chat/mySub */
export async function stockCaseChatMySubUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseChatMySubUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/chat/mySub', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户案例关注剩余次数 GET /stock/case/chat/subCount */
export async function stockCaseChatSubCountUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultSubStockCaseCountResp>('/stock/case/chat/subCount', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 聊天室案例操作列表 GET /stock/case/deal/list */
export async function stockCaseDealListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseDealListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/deal/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取股票池案例详情 GET /stock/case/info */
export async function stockCaseInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCaseInfoResp>('/stock/case/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表(1.0) GET /stock/case/l1/list */
export async function stockCaseL1ListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseL1ListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/l1/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表(1.0) GET /stock/case/l1/list/pool */
export async function stockCaseL1ListPoolUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseL1ListPoolUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/l1/list/pool', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池列表总结 GET /stock/case/l1/pool/summary */
export async function stockCaseL1PoolSummaryUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseL1PoolSummaryUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCasePoolSummaryResp>('/stock/case/l1/pool/summary', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取最后一条案例操作 GET /stock/case/lastCaseDeal */
export async function stockCaseLastCaseDealUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseLastCaseDealUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCaseDealResp>('/stock/case/lastCaseDeal', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表 GET /stock/case/list */
export async function stockCaseListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 栏目文章关联的案例股票池 GET /stock/case/list-by-article */
export async function stockCaseListByArticleUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseListByArticleUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockCaseDetailResp>('/stock/case/list-by-article', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 按回放视频查询案例列表 GET /stock/case/list-by-video */
export async function stockCaseListByVideoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseListByVideoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockCaseResp>('/stock/case/list-by-video', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取股票池案例180天内最高涨幅 GET /stock/case/maxRatio */
export async function stockCaseMaxRatioUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseMaxRatioUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCaseProfitResp>('/stock/case/maxRatio', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票最新动态 GET /stock/case/news */
export async function stockCaseNewsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseNewsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseNewsResp>('/stock/case/news', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 一档栏目公告(股票池) GET /stock/case/notice */
export async function stockCaseNoticeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseNoticeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseNoticeResp>('/stock/case/notice', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 一档栏目公告(股票池) GET /stock/case/notice/pool */
export async function stockCaseNoticePoolUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseNoticePoolUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseNoticeResp>('/stock/case/notice/pool', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池列表(PC端) GET /stock/case/pc */
export async function stockCasePcUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCasePcUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListPcStockCaseDetailResp>('/stock/case/pc', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池列表 GET /stock/case/pool/list */
export async function stockCasePoolListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCasePoolListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStockCaseResp>('/stock/case/pool/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 上榜股票 GET /stock/case/rank */
export async function stockCaseRankUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseRankUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/rank', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 上榜股票(股票池) GET /stock/case/rank/pool */
export async function stockCaseRankPoolUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseRankPoolUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseDetailResp>('/stock/case/rank/pool', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池信号列表(PC端) GET /stock/case/signal */
export async function stockCaseSignalUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseSignalUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListPcStockCaseSignalResp>('/stock/case/signal', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股池收益概览-明细tab GET /stock/case/statistics/profit-list */
export async function stockCaseStatisticsProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStatisticsProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseChannelStatisticsProfitResp>(
    '/stock/case/statistics/profit-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 股池收益概览-战绩tab GET /stock/case/statistics/record-list */
export async function stockCaseStatisticsRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStatisticsRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCaseChannelStatisticsProfitResp>(
    '/stock/case/statistics/record-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 股池收益概览-统计tab GET /stock/case/statistics/summary */
export async function stockCaseStatisticsSummaryUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStatisticsSummaryUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCaseChannelStatisticsSummaryResp>('/stock/case/statistics/summary', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表(1.0) GET /stock/case/stockDetail */
export async function stockCaseStockDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStockDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCaseDetailResp>('/stock/case/stockDetail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-案例列表(1.0) GET /stock/case/stockDetail/pool */
export async function stockCaseStockDetailPoolUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStockDetailPoolUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockCaseDetailResp>('/stock/case/stockDetail/pool', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略组持仓列表（l3） GET /stock/case/strategy */
export async function stockCaseStrategyUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultStrategyResp>('/stock/case/strategy', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 策略组概览明细(去掉行情调用) GET /stock/case/strategy/detail */
export async function stockCaseStrategyDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStrategyDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyStockCaseResp>('/stock/case/strategy/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略组持仓操作列表 GET /stock/case/strategy/stockDealList */
export async function stockCaseStrategyStockDealListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseStrategyStockDealListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyStockDealResp>('/stock/case/strategy/stockDealList', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股票池-关注/取关 POST /stock/case/sub/editSubInfo */
export async function stockCaseSubEditSubInfoUsingPOST(
  body: API.EditStockCaseSubInfoReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/stock/case/sub/editSubInfo', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
